export default __webpack_public_path__ + "static/media/no_image.da301589.jpg";